import * as React from "react";
import { NavigationStep } from "../../types";
import { Link } from "react-router-dom";
import { RefObject } from "react";
import { Patient } from "../../patient/types";
import { User, canManagePatients } from "../../session/types";
import { Organization } from "../../organizations/types";

interface OwnProps {
  patient: Patient;
  user: User | null;
  organization: Organization | null;
  setPatientAndAct: (patient: Patient, step: NavigationStep) => void;
  deactivatePatient: (patient: Patient) => void;
}

interface OwnState {
  showMenu: boolean;
}

type Props = OwnProps;

class ActionDropdown extends React.PureComponent<Props, OwnState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected dropdownMenu: RefObject<HTMLDivElement>;
  constructor(props: Props) {
    super(props);

    this.state = {
      showMenu: false
    };

    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.patientDeactivate = this.patientDeactivate.bind(this);
    this.dropdownMenu = React.createRef<HTMLDivElement>();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public showMenu(event: any) {
    event.preventDefault();

    this.setState({ showMenu: true }, () => {
      document.addEventListener("click", this.closeMenu);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public closeMenu(event?: any) {
    if ((event && !this.dropdownMenu.current?.contains(event.target)) || !event) {
      this.setState({ showMenu: false }, () => {
        document.removeEventListener("click", this.closeMenu);
      });
    }
  }

  public patientAction = (step: NavigationStep) => {
    if (this.props.patient) {
      this.props.setPatientAndAct(this.props.patient, step);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public patientDeactivate = () => {
    if (this.props.patient) {
      this.props.deactivatePatient(this.props.patient);
    }
    this.closeMenu();
  };

  render() {
    const { patient, user, organization } = this.props;
    return (
      <div className="actionContainer">
        <div className="icon-container" onClick={this.showMenu} role="button" tabIndex={0}>
          <i className="fas fa-ellipsis-h icon" />
        </div>

        {this.state.showMenu ? (
          <div className="menu" ref={this.dropdownMenu}>
            <Link to={`/patient/${patient.id}/`}>
              <div className="link" role="button" tabIndex={0}>
                {canManagePatients(user) && "Update /"} View Patient
              </div>
            </Link>

            {!organization?.smsCommunicationDisabled && (
              <div
                className="link"
                role="button"
                tabIndex={0}
                onClick={() => this.patientAction(NavigationStep.MessagePatient)}
              >
                Message Patient
              </div>
            )}
            {user && user.featureFlags?.enableVideo && !organization?.smsCommunicationDisabled && (
              <div
                className="link"
                role="button"
                tabIndex={0}
                onClick={() => this.patientAction(NavigationStep.VideoChatSms)}
              >
                Text Video Visit Invite
              </div>
            )}
            {user && user.featureFlags?.enableVideo && organization?.enableSendingEmail && (
              <div
                className={!patient?.email ? "link disabled" : "link"}
                role="button"
                tabIndex={0}
                onClick={() => this.patientAction(NavigationStep.VideoChatEmail)}
              >
                Email Video Visit Invite
              </div>
            )}
            {!organization?.smsCommunicationDisabled && (
              <div
                className="link"
                role="button"
                tabIndex={0}
                onClick={() => this.patientAction(NavigationStep.MessageFamily)}
              >
                Message Family
              </div>
            )}
            {user && user.featureFlags?.enableVideo && !organization?.smsCommunicationDisabled && (
              <Link to={`/patient/${patient?.id}/family/`}>
                <div className="link" role="button">
                  Video Visit with Family
                </div>
              </Link>
            )}
            {canManagePatients(user) && patient.isActive && (
              <div
                className="link"
                role="button"
                tabIndex={0}
                onClick={() => this.patientDeactivate()}
              >
                Deactivate Patient
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  }
}

export default ActionDropdown;
